import React, { Fragment } from 'react'
import styled from 'styled-components'
import { BsLightningFill } from 'react-icons/bs'
import { FaLock } from 'react-icons/fa'
import { TABLET } from '../../utilities/breakpoints'

const DiscussionTopicMeta = ({closed, questions, useTranslate}) => {

  return (
    <Container>
      <StateIndicator className="state-indicator">
        {!closed ?
          <Fragment><BsLightningFill/>{useTranslate('discussion.active_topic')}</Fragment>
          :
          <Fragment><FaLock/>{useTranslate('discussion.closed_topic')}</Fragment>
        }
      </StateIndicator>
      <DividerBullet />{questions && questions.length} {useTranslate('discussion.questions')}
    </Container>
  )
}

export default DiscussionTopicMeta;

const Container = styled.div`
  font-size: 16px;
  color: #5F7D95;
  display: flex;
  align-items: center;
  white-space: nowrap;
  
  @media${TABLET} {
    font-size: 18px;
  }
`;

const StateIndicator = styled.span`
  display: flex;
  align-items: center;

  svg {
    height: 0.875em;
    margin-right: 5px;
  }
`;

const DividerBullet = styled.span`
  margin: 0 10px;
  
  &:before {
    content: '\\2022';
  } 
`;


// WEBPACK FOOTER //
// ./src/components/discussion/discussion-topic-meta.js